import React, { useState, useRef, useEffect, createContext, useContext } from 'react';

const ContextMenuContext = createContext(null);

const ContextMenu = ({
  trigger,
  children,
  align = 'right',
  animate = true,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const menuStyles = animate
    ? `transform transition-all duration-200 ease-out
    ${isOpen
      ? 'opacity-100 translate-y-0 pointer-events-auto'
      : 'opacity-0 -translate-y-2 pointer-events-none'
    }`
    :
    `${isOpen
      ? 'opacity-100 pointer-events-auto'
      : 'opacity-0 pointer-events-none'
    }`;

  return (
    <ContextMenuContext.Provider value={{ isOpen, setIsOpen }}>
      <div className={`relative ${className}`} ref={menuRef}>
        <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
          {trigger}
        </div>
        <div className={`absolute ${align === 'right' ? 'right-0' : 'left-0'} top-full mt-1 min-w-[12rem] rounded-md border border-gray-less bg-gray-weak shadow-lg ring-1 ring-black ring-opacity-5 z-50 ${menuStyles}`}>
          <div className="py-1">
            {children}
          </div>
        </div>
      </div>
    </ContextMenuContext.Provider>
  );
};

const ContextMenuItem = ({
  children,
  icon,
  className = '',
  onClick,
  disabled = false
}) => {
  const { setIsOpen } = useContext(ContextMenuContext);

  const handleClick = () => {
    if (!disabled) {
      onClick?.();
      setIsOpen(false);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`${disabled
        ? 'text-gray-mid cursor-not-allowed'
        : 'text-gray-strongest hover:bg-gray-less cursor-pointer'
        } ${className} px-4 py-2 text-sm flex items-center gap-2`}
    >
      {icon && <span className="w-4">{icon}</span>}
      {children}
    </div>
  );
};

const ContextMenuSeparator = () => (
  <div className="h-px bg-gray-mid my-1" />
);

ContextMenu.Item = ContextMenuItem;
ContextMenu.Separator = ContextMenuSeparator;

export { ContextMenu, ContextMenuItem, ContextMenuSeparator };
